module.exports = __webpack_public_path__ + "img/611.4b492d34.png";